import type { ServerResponse } from "@/http"
import type { IEventVaultResponse } from "@/types"
import { useMutation } from "@tanstack/vue-query"
import { axios } from "@/axios"
import { EventVault } from "@/models"

export async function updateEventVault(eventVault: EventVault) {
  if (!eventVault.id) {
    throw new Error(
      "Missing `eventVault.id` when attempting to update an event vault. Please ensure `eventVault.id` is provided.",
    )
  }

  const TEN_MINUTES_MS = 600000

  const endpoint = `/api/event/${eventVault.id}`

  const response = await axios.patchForm<ServerResponse<IEventVaultResponse>>(endpoint, EventVault.toRequest(eventVault), {
    timeout: TEN_MINUTES_MS,
  })

  return EventVault.fromResponse(response.data.Data)
}

export function useUpdateEventVault() {
  return useMutation({
    mutationFn: (vault: EventVault) => updateEventVault(vault),
  })
}
